/* eslint-disable no-unused-vars */

import Vue from "vue";
import * as CONFIG from "../../config.js";
import { jwtDecode } from "jwt-decode";

const endpoints = {
    obtainJWT: "/api-token-auth/",
    verifyJWT: "/api-token-verify/",
    refreshJWT: "/api-token-refresh/",
    expireJWT: "/api-token-expire/",

    getPermissions: "/api/ocom/my_group_permissions/",
    forgot_password: "/auth/forgot_password/",
    verify_passcode: "/auth/verify_passcode/",
    change_password: "/auth/change_password/",
    sudo: "/auth/sudo/",

    baseUrl: CONFIG.root_url || "",
};

// send login data and retrive a new token
export const postLogin = ({ username, password }) => {
    return new Promise((resolve, reject) => {
        Vue.axios
            .post(endpoints.baseUrl + endpoints.obtainJWT, {
                username: username,
                password: password,
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getPermissions = (token) => {
    return new Promise((resolve, reject) => {
        // When JWT_COOKIE_ONLY is enabled, don't set Authorization header
        // Authentication is handled via HTTP-only cookies
        var headers = CONFIG.JWT_COOKIE_ONLY
            ? {}
            : { Authorization: "bearer " + token };

        Vue.axios
            .post(
                endpoints.baseUrl + endpoints.getPermissions,
                {},
                { headers: headers },
            )
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const forgotPassword = (username) => {
    return new Promise((resolve, reject) => {
        Vue.axios
            .post(endpoints.baseUrl + endpoints.forgot_password, {
                username: username,
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const verifyPasscode = (username, key) => {
    return new Promise((resolve, reject) => {
        Vue.axios
            .post(endpoints.baseUrl + endpoints.verify_passcode, {
                username: username,
                key: key,
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const changePassword = (password, token) => {
    return new Promise((resolve, reject) => {
        // When JWT_COOKIE_ONLY is enabled, don't set Authorization header
        // Authentication is handled via HTTP-only cookies
        var headers = CONFIG.JWT_COOKIE_ONLY
            ? {}
            : { Authorization: "bearer " + token };

        Vue.axios
            .post(
                endpoints.baseUrl + endpoints.change_password,
                { password: password },
                { headers: headers },
            )
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const refreshToken = (token, isRefreshToken = false) => {
    return new Promise((resolve, reject) => {
        // Use correct parameter name based on token type
        // djangorestframework-simplejwt expects 'refresh' parameter
        // Old library expected 'token' parameter (for backward compatibility)
        var data = isRefreshToken ? { refresh: token } : { token: token };

        Vue.axios
            .post(endpoints.baseUrl + endpoints.refreshJWT, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

// revoke current token
export const revokeToken = (token) => {
    // When JWT_COOKIE_ONLY is enabled, don't set Authorization header
    // Authentication is handled via HTTP-only cookies
    var headers = CONFIG.JWT_COOKIE_ONLY
        ? {}
        : { Authorization: "bearer " + token };

    return Vue.axios.post(
        endpoints.baseUrl + endpoints.expireJWT,
        {},
        { headers: headers },
    );
};

export const loadUserData = () => {
    return new Promise((resolve, reject) => {
        resolve();
    });
};

export const isAuthDisabled = () => {
    if ("authDisabled" in CONFIG) {
        return !!CONFIG.authDisabled;
    }

    return false; // not disabled
};

export const decodeJWT = (token) => {
    var decoded = jwtDecode(token);
    if (Date.now() >= decoded.exp * 1000) {
        console.log("Expired JWT Token");
        throw "Token Expired";
    }
    return decoded;
};

export const sudo = (user_id, token) => {
    return new Promise((resolve, reject) => {
        // When JWT_COOKIE_ONLY is enabled, don't set Authorization header
        // Authentication is handled via HTTP-only cookies
        var headers = CONFIG.JWT_COOKIE_ONLY
            ? {}
            : { Authorization: "bearer " + token };

        var data = {
            id: user_id,
        };

        Vue.axios
            .post(endpoints.baseUrl + endpoints.sudo, data, {
                headers: headers,
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
};
